/* tslint:disable */
/* eslint-disable */
/**
 * Commerce Webservices
 * Manages all of the common commerce functionality, and also includes customizations from installed AddOns. The implementing extension is called commercewebservices.
 *
 * The version of the OpenAPI document: 2.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Price } from './Price';
import {
    PriceFromJSON,
    PriceFromJSONTyped,
    PriceToJSON,
} from './Price';
import type { Stock } from './Stock';
import {
    StockFromJSON,
    StockFromJSONTyped,
    StockToJSON,
} from './Stock';
import type { VariantOptionQualifier } from './VariantOptionQualifier';
import {
    VariantOptionQualifierFromJSON,
    VariantOptionQualifierFromJSONTyped,
    VariantOptionQualifierToJSON,
} from './VariantOptionQualifier';

/**
 * Representation of a Variant Option
 * @export
 * @interface VariantOption
 */
export interface VariantOption {
    /**
     * Code of the variant option
     * @type {string}
     * @memberof VariantOption
     */
    code?: string;
    /**
     * 
     * @type {Stock}
     * @memberof VariantOption
     */
    stock?: Stock;
    /**
     * Url address of the variant option
     * @type {string}
     * @memberof VariantOption
     */
    url?: string;
    /**
     * 
     * @type {Price}
     * @memberof VariantOption
     */
    priceData?: Price;
    /**
     * List of variant option qualifiers
     * @type {Array<VariantOptionQualifier>}
     * @memberof VariantOption
     */
    variantOptionQualifiers?: Array<VariantOptionQualifier>;
}

/**
 * Check if a given object implements the VariantOption interface.
 */
export function instanceOfVariantOption(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function VariantOptionFromJSON(json: any): VariantOption {
    return VariantOptionFromJSONTyped(json, false);
}

export function VariantOptionFromJSONTyped(json: any, ignoreDiscriminator: boolean): VariantOption {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'code': !exists(json, 'code') ? undefined : json['code'],
        'stock': !exists(json, 'stock') ? undefined : StockFromJSON(json['stock']),
        'url': !exists(json, 'url') ? undefined : json['url'],
        'priceData': !exists(json, 'priceData') ? undefined : PriceFromJSON(json['priceData']),
        'variantOptionQualifiers': !exists(json, 'variantOptionQualifiers') ? undefined : ((json['variantOptionQualifiers'] as Array<any>).map(VariantOptionQualifierFromJSON)),
    };
}

export function VariantOptionToJSON(value?: VariantOption | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'code': value.code,
        'stock': StockToJSON(value.stock),
        'url': value.url,
        'priceData': PriceToJSON(value.priceData),
        'variantOptionQualifiers': value.variantOptionQualifiers === undefined ? undefined : ((value.variantOptionQualifiers as Array<any>).map(VariantOptionQualifierToJSON)),
    };
}

